export var FilterOptionSource = /*#__PURE__*/function (FilterOptionSource) {
  /**
   * This means the result came from collab graph
   */
  FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
  /**
   * This means the result came from smart user picker
   */
  FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
  /**
   * This means the result came from a recents (bootstrap) query
   */
  FilterOptionSource["RECENT"] = "RECENT";
  /**
   * This means the result came from an explicit search
   */
  FilterOptionSource["SEARCH"] = "SEARCH";
  /**
   * This means the result is derived from the current user
   */
  FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
  /**
   * This means the result came from an external source passed into the component
   */
  FilterOptionSource["EXTERNAL"] = "EXTERNAL";
  /**
   * This means the result is static without any user-generation
   */
  FilterOptionSource["STATIC"] = "STATIC";
  return FilterOptionSource;
}({});